import React from "react";

// Fixed 3D pastel mesh-gradient background.
// Uses heavily blurred absolute divs over a warm base color.
export const MeshBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 z-[-1] overflow-hidden bg-[#FFF9EE]"
      data-testid="mesh-background"
    >
      <div className="absolute top-[-15%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-[#FFD1D1] opacity-70 blur-[110px] mix-blend-multiply blob-anim-1" />
      <div className="absolute bottom-[-15%] right-[-10%] w-[65vw] h-[65vw] rounded-full bg-[#E8D1FF] opacity-70 blur-[130px] mix-blend-multiply blob-anim-2" />
      <div className="absolute top-[25%] right-[5%] w-[45vw] h-[45vw] rounded-full bg-[#D1FFEB] opacity-70 blur-[110px] mix-blend-multiply blob-anim-3" />
      <div className="absolute bottom-[20%] left-[10%] w-[40vw] h-[40vw] rounded-full bg-[#FFF5D1] opacity-80 blur-[100px] mix-blend-multiply blob-anim-4" />
      {/* subtle grain */}
      <div
        className="absolute inset-0 opacity-[0.08] mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  );
};
